import React, { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { TriangleSlider } from '../../../slider';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { AppSkinProps } from '../../../../types/decisions';

const AppCriteriaTypeDate = ({
    importance,
    hideValues,
    hideImportance,
    onSliderChange,
    onTradeoffValueChange,
    showAddConstraint,
    value,
    id,
}: {
    importance: number;
    hideValues?: boolean;
    hideImportance?: boolean;
    showAddConstraint?: boolean;
    onSliderChange: AppSkinProps['onSliderChange'];
    onTradeoffValueChange: (value: any, id: string, key: string) => void;
    value: string;
    id: string;
}) => {
    const [ dateValue, setDateValue ] = useState<Dayjs | null>(dayjs(value));

    const onDateChange = (value: Dayjs | null) => {
        setDateValue(value);
        const dateString = value?.format('MM/DD/YYYY');
        onTradeoffValueChange(dateString, id, '');
    };

    return (
        <div>
            {hideValues ? null : (
                <div style={{ marginBottom: 10 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={[ 'MuiDateField' ]}>
                            <DesktopDatePicker
                                label="Date"
                                value={dateValue}
                                onChange={onDateChange}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                </div>
            )}
            {hideImportance ? null : (
                <div>
                    <TriangleSlider
                        min={0}
                        max={100}
                        step={1}
                        value={importance}
                        leftText="Not Important"
                        rightText="Really Important"
                        onChange={(_, value) => onSliderChange(value as number, id)}
                    />
                </div>
            )}
            {!showAddConstraint ? null : (
                <div style={{ marginTop: 20 }}>
                    <Button
                        variant="outlined"
                        startIcon={<AddIcon/>}
                        size="small"
                    >
                        Add Constraint
                    </Button>
                </div>
            )}
        </div>
    );
};

export default AppCriteriaTypeDate;
